export const INDICES_STATUSES = `
    query _ {
        index_field_status_list {
            id
            status_name
        }
    }
`;
